import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltActivityLogHeaderFilterTriggerIconWireframe from './VeltActivityLogHeaderFilterTriggerIconWireframe/VeltActivityLogHeaderFilterTriggerIconWireframe';
import VeltActivityLogHeaderFilterTriggerLabelWireframe from './VeltActivityLogHeaderFilterTriggerLabelWireframe/VeltActivityLogHeaderFilterTriggerLabelWireframe';
var VeltActivityLogHeaderFilterTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-header-filter-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogHeaderFilterTriggerWireframe.Icon = VeltActivityLogHeaderFilterTriggerIconWireframe;
VeltActivityLogHeaderFilterTriggerWireframe.Label = VeltActivityLogHeaderFilterTriggerLabelWireframe;
export default VeltActivityLogHeaderFilterTriggerWireframe;
